import { QueryClient } from '@tanstack/react-query'

/**
 * Single TanStack Query client for apps/boombox. Boombox exists to check
 * real data, so the defaults are freshness-first: every mount refetches
 * (`staleTime: 0` + `refetchOnMount: 'always'`) exactly like the hand-rolled
 * hooks this replaces — TanStack adds request dedup, in-flight sharing, and
 * previous-data placeholders (with loading indicators), never stale serves.
 * `retry: false` preserves the old hooks' fail-fast error surfacing.
 *
 * Same config as apps/customers (`apps/customers/client/src/lib/query-client.ts`),
 * whose migration this one mirrors.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
